import { fmtDateTime } from '@/lib/format';
import { useTimezone } from '@/lib/org';

export const useTz = useTimezone;
export { fmtDateTime };
